import { Head } from "@inertiajs/react";
import { Plus } from "lucide-react";
import { useState } from "react";
import BizminerAdminLayout from "@/bizminer/layouts/admin/BizminerAdminLayout.tsx";
import { Button } from "@/components/ui/button";
import type { PagyMetadata } from "@/types/Pagy";
import type { BizminerAdminOrganizationList } from "@/types/serializers";
import { CreateOrganizationDialog } from "./_components/CreateOrganizationDialog";
import OrganizationsTable from "./_components/OrganizationsTable";
import PageHeader from "./_components/PageHeader";

interface Props {
  organizations: BizminerAdminOrganizationList[];
  pagy: PagyMetadata;
}

export default function Index({ organizations, pagy }: Props) {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  return (
    <BizminerAdminLayout>
      <Head title="Manage Organizations - Super Admin - SalesMinr" />
      <div className="min-h-screen bg-background">
        <PageHeader
          title="Manage Organizations"
          actions={
            <Button onClick={() => setCreateDialogOpen(true)}>
              <Plus className="h-4 w-4 mr-2" />
              Create Organization
            </Button>
          }
        />

        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <OrganizationsTable organizations={organizations} pagy={pagy} />
          </div>
        </div>
      </div>

      <CreateOrganizationDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
      />
    </BizminerAdminLayout>
  );
}
